import { render, staticRenderFns } from "./cancellation_reminder.vue?vue&type=template&id=27bc381a&scoped=true&lang=html&"
import script from "./cancellation_reminder.vue?vue&type=script&lang=js&"
export * from "./cancellation_reminder.vue?vue&type=script&lang=js&"
import style0 from "./cancellation_reminder.vue?vue&type=style&index=0&id=27bc381a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc381a",
  null
  
)

export default component.exports